import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const ChannelListChannelTextContainer = styled.div<React.CSSProperties>`
  display: flex;
  overflow: hidden;
  width: ${220 * Screen.widthRatio}px;
`;

export default ChannelListChannelTextContainer;
